import CTScanNav from "../../pages/Dashboard/CTScan/CTScanNav";
import CTScanIndex from "../../pages/Dashboard/CTScan/CTScanIndex";
import CTScanTestsPage from "../../pages/Dashboard/CTScan/CTScanTestsPage";
import PatientCTScanRecordsPage from "../../pages/Dashboard/CTScan/PatientCTScanRecordsPage";
import CTScanRecordDetailsPage from "../../pages/Dashboard/CTScan/CTScanRecordDetailsPage";

const ctScanRoutes = {
  path: "/ct-scan",
  element: <CTScanNav />,
  children: [
    { path: "/ct-scan", element: <CTScanIndex /> },
    { path: "/ct-scan/tests", element: <CTScanTestsPage /> },
    { path: "/ct-scan/patient-records", element: <PatientCTScanRecordsPage /> },
    { path: "/ct-scan/patient-records/:id", element: <CTScanRecordDetailsPage /> },
  ],
};

export default ctScanRoutes;

